import {axios as http} from "@/plugins/http"

export default class Api {
    static item(query) {
        let config = {
            params: query,
        }

        return http.get("/api/v1/post/site/tags/item", config);
    }

    static create(query) {
        return http.post("/api/v1/post/site/tags/create", query);
    }

    static update(query) {
        return http.post("/api/v1/post/site/tags/update", query);
    }
}
